import axios from "axios";
import {BASE_URL} from "../contants/network";
import {PAGE_SIZE} from "../consts/pageSize";
import {PlatformParamsProps} from "../context/UserContext";
import * as crypto from "crypto";

export interface CallProps {
    endpoint: string;
    method: 'GET' | 'POST' | 'PATCH' | 'PUT' | 'DELETE';
    params?: any;
    headers?: any;
    domain?: string;
    platformParams?: PlatformParamsProps;
    isEncrypted?: boolean;
    abortSignal?: any
}

export const call = async ({endpoint, method, params = {}, headers = {}, abortSignal}: CallProps) => {
    const connector = endpoint.includes('?') ? '&' : '?';
    if(method === 'GET') {
        const keys = Object.keys(params).filter(paramKey => !endpoint.includes(`${paramKey}=`));
        const joinedParams = keys.length ? `&${keys.map(paramKey => `${paramKey}=${params[paramKey]}`).join('&')}` : '';
        return axios.get(`${BASE_URL}${endpoint}${connector}platform=independent&pageSize=${PAGE_SIZE}${joinedParams}`, { headers, signal: abortSignal });
    }
    if(method === 'POST') {
        try {
            const res = await axios.post(`${BASE_URL}${endpoint}`, {platform: "independent", ...params}, {
                headers,
                signal: abortSignal
            });
            return res;
        } catch (error: any) {
            if(error.code === "ERR_CANCELED") {
                return {
                    data: null,
                    status: -1
                }
            }
        }
    }
    if(method === 'PATCH') {
        return axios.patch(`${BASE_URL}${endpoint}`, { platform: "independent", ...params }, { headers, signal: abortSignal });
    }
    if(method === 'PUT') {
        return axios.put(`${BASE_URL}${endpoint}`, { platform: "independent", ...params }, { headers, signal: abortSignal });
    }
    if(method === 'DELETE') {
        return axios.delete(`${BASE_URL}${endpoint}`, { headers, data: { platform: "independent", ...params }, signal: abortSignal });
    }
    return null;
};